import useQuery from '@cbgms/base/http/use-query'
import { getOnboardingRegions } from 'app/auth/state/actions'
import { useDispatch } from 'react-redux'

export const useGetOnboardingRegions = () => {
  const dispatch = useDispatch()

  return useQuery(['ONBOARDING', 'REGIONS'], async () => {
    const { Data } = await dispatch(getOnboardingRegions())
    return Data.map(({ Name, UUID }) => ({
      text: Name,
      value: UUID,
      key: UUID
    }))
  })
}
